import React, { useState, useEffect } from "react";
import useStyles from "./styles";
import { useHistory } from "react-router-dom";
import config from "../../config"
import { debounce } from "lodash";

// components
import PageTitle from "../../components/PageTitle/PageTitle";
import Widget from "../../components/Widget/Widget";
import Table from "./StockTable";
import Modal from "../modals/Modal";
import { Grid } from "@material-ui/core";
import * as Icons from "@material-ui/icons";

export default function Stock() {
  const classes = useStyles();
  const history = useHistory();

  const [baseUrl, setBaseUrl] = useState(config.config[0].baseUrl + 'productStock/page/');
  const [allData, setAllData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [accumulatedItems, setAccumulatedItems] = useState(0);
  const [itemsOnPage, setItemsOnPage] = useState(0);
  const [totalItems, setTotalItems] = useState(0);
  const [showModal, setShowModal] = useState(false);
  const [isSearch, setIsSearch] = useState(false);

  const closeModalLogin = e => {
    setShowModal(false);
  }

  const delayedHandleChange = debounce(search => {
    if (search != '') {
      setIsSearch(true);
      fetch(config.config[0].baseUrl + 'searchProductStockList/' + search,
      {
        headers: {
          'Accept': 'application/json', 'Content-Type': 'application/json',
          'Authorization': localStorage.getItem("token")
        },
      }
    ).then((res) => res.json())
      .then((json) => {
        setFilteredData(json);
      });
    } else {
      setIsSearch(false);
      setFilteredData(allData);
    }
    
  }, 700);

  const handleChange = (e) => {
    delayedHandleChange(e.target.value.toLowerCase());
  }

  const fetchProducts = async () => {
    fetch(baseUrl + 0,
      {
        headers: {
          'Accept': 'application/json', 'Content-Type': 'application/json',
          'Authorization': localStorage.getItem("token")
        },
      }).then(response => response.json())
      .then(data => {
        const newData = data.content;

        if (newData != null) {
          setAllData(newData);
          setFilteredData(newData);
          setTotalPages(data.totalPages);
          setAccumulatedItems(data.numberOfElements);
          setItemsOnPage(data.numberOfElements);
          setTotalItems(data.totalElements);
        } else {
          setTotalPages(0);
          setCurrentPage(0);
          setShowModal(true);
        }
      })
      .catch(error => null);
  }

  useEffect(() => {
    fetchProducts();
  }, []);

  const onNextPage = e => {
    if (currentPage < totalPages) {
      fetch(baseUrl + currentPage,
        {
          headers: {
            'Accept': 'application/json', 'Content-Type': 'application/json',
            'Authorization': localStorage.getItem("token")
          },
        }).then(response => response.json())
        .then(data => {
          const newData = data.content;

          if (newData != null) {
            setAllData(newData);
            setFilteredData(newData);
            setTotalPages(data.totalPages);
            setCurrentPage(data.number + 1);
            setAccumulatedItems(accumulatedItems + data.numberOfElements);
            setItemsOnPage(data.numberOfElements);
            setTotalItems(data.totalElements);
          } else {
            setShowModal(true);
          }
        })
        .catch(error => null);
    }
  }

  const onPreviousPage = e => {
    if (currentPage > 1) {
      fetch(baseUrl + (currentPage - 2),
        {
          headers: {
            'Accept': 'application/json', 'Content-Type': 'application/json',
            'Authorization': localStorage.getItem("token")
          },
        }).then(response => response.json())
        .then(data => {
          const newData = data.content;

          if (newData != null) {
            setAllData(newData);
            setFilteredData(newData);
            setTotalPages(data.totalPages);
            setCurrentPage(data.number + 1);
            setAccumulatedItems(accumulatedItems - itemsOnPage);
            setItemsOnPage(data.numberOfElements);
            setTotalItems(data.totalElements);
          } else {
            setShowModal(true);
          }
        })
        .catch(error => null);
    }
  }

  const onClickRow = (property) => (event) => {
    localStorage.setItem('productInfo', property);
    history.push({
      pathname: '/app/productInfo',
      state: { id: property }
    });
  };

  return (
    <div>
      {showModal ? (
        <Modal
          isOpen={showModal}
          closeModal={closeModalLogin}
        />
      ) : (
        <></>
      )}

      <PageTitle title="Stock" />

      <div className={classes.divHeader} >
        <div className={classes.div} >
          <input
            className={classes.inputSearch}
            type="text"
            onChange={(event) => handleChange(event)}
          />
          <div className={classes.divSearch} >
            <Icons.Search classes={{ root: classes.searchIcon }} />
          </div>
        </div>

        <div className={classes.divAddButton} >
          <Icons.Add classes={{ root: classes.searchIcon }}
            onClick={() =>
              history.push('/app/addProduct')
            }
          />
        </div>
      </div>

      <Grid item xs={12}>
        <Widget
          noBodyPadding
          bodyClass={classes.tableWidget}
        >
          <Table
            data={filteredData}
            currentPage={currentPage}
            totalPages={totalPages}
            onPreviousPage={onPreviousPage}
            onNextPage={onNextPage}
            onClick={onClickRow}
            accumulatedItems={accumulatedItems}
            totalItems={totalItems}
            isSearch={isSearch}
          />
        </Widget>
      </Grid>
    </div>
  );
}
